app.service("productUpselling", function (
	store,
	sticky,
	productCardManager,
	productCardConfig,
	productPriceTabs,
	productStateSection,
	salesBox,
	partnerSubscription,
	productWarranty,
	servicesSection,
	productInstalmentsSection,
	warrantyQuestionnaire,
	captchaService
) {
	let config, $self, $contentPlaceholder;

	function init() {
		config = productCardConfig.getData();
		$self = $('#product-upselling');
		$contentPlaceholder = $('#product-upselling-content-placeholder');

		if (config.preview) {
			$contentPlaceholder.hide();
			$self.removeClass('initial');
			return;
		}

		store.onChange(loadProductUpselling);
		loadProductUpselling();
	}

	function loadProductUpselling() {
		if(!$self.find($contentPlaceholder).length) {
			$self.addClass('loading');
		}

		fetchProductUpselling()
			.then(html => {
				render(html);
				initModules();
				sticky.rebuild('productUpselling');
			})
			.fail(() => {
				$self.text('Błąd ładowania sekcji. Odśwież stronę, aby spróbować ponownie.');
			})
			.always(() => {
				$self.removeClass('loading initial');
			});
	}

	function fetchProductUpselling() {
		return $.ajax({
			url: '/web-cached/product-detail/selling-section.ltr',
			data: {
				productId: config.id,
				outletCategoryId: store.data.outletCategoryId || undefined,
				instalmentCode: store.data.instalmentCode || undefined,
				instalmentNumber: store.data.instalmentNumber || undefined
			}
		});
	}

	function render(html) {
		$self.html(html);
	}

	function addAvailabilityNotificationFormCaptcha() {
		const $captcha = $self.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}

	function initModules() {
		const props = {
			$el: $self
		};
		productPriceTabs.init(props);
		productStateSection.init(props);
		salesBox.init(props);
		partnerSubscription.init(props);
		productWarranty.init(props);
		servicesSection.init(props);
		productInstalmentsSection.init(props);
		warrantyQuestionnaire.markAnswers();
		addAvailabilityNotificationFormCaptcha();
	}

	return {
		init
	};
});